<template>
    <div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <table class="full-table">
                <tbody>
                    <tr>
                        <th colspan="42">
                            <div class="table-filters">
                                <div>Edit Department, Type, and Process Owner</div>
                            </div>
                        </th>
                    </tr>
                    <tr class="table-labels">
                        <td>Name</td>
                        <td>Type</td>
                        <td>Last Modified</td>
                        <td>Last Modified By</td>
                        <td>Process Owner</td>
                        <td></td>
                    </tr>
                    <tr v-for="(process, i) in processes" :key="i">
                        <td>
                            <router-link :to="'/playbook/' + process.Slug"><svg-icon style="width: 18px;height:18px;margin-bottom:-3px" v-if="process.Mine" icon="star" /> {{ process.Name }}</router-link>
                        </td>
                        <td>{{ $store.state.playbookNodeTypeMap[process.Type] }}</td>
                        <td>{{ process.LastModifiedString }}</td>
                        <td>{{ process.LastUpdatedBy }}</td>
                        <td>{{ process.ProcessOwnerNames }}</td>
                        <td v-if="$store.state.adminRolesCanEdit.includes($store.state.user.role)" style="text-align:center">
                            <a @click.prevent="editProcess(process, i)">Edit</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <add-edit-node v-if="showEditNode" :node="nodeToEdit" @close="closeEditProcess()" />
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import AddEditNode from '@/components/AddEditNode.vue';
import SvgIcon from '@/components/SvgIcon.vue';

export default defineComponent({
    name: 'NodesView',
    components: {
        AddEditNode,
    },
    data() {
        return {
            processes: [] as any,
            showEditNode: false,
            nodeToEdit: null as any,
            nodeToEditIndex: 0
        }
    },
    async created() {
        await this.getProcesses();

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getProcesses() {
            await axios.get(`${this.$store.state.apiUrl}/api/playbook/fixnodes`)
                .then(resp => {
                    resp.data.forEach((p: any) => {
                        if(p.LastModified) {
                            p.LastModifiedString = new Date(p.LastModified).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
                        }
                    });
                    this.processes = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        async editProcess(process: any, i: number) {
            this.nodeToEdit = process;
            this.showEditNode = true;
            this.nodeToEditIndex = i;
        },
        closeEditProcess() {
            this.processes.splice(this.nodeToEditIndex, 1);
            this.showEditNode = false;
        }
    }
});
</script>
